// Global Buttonlist for components that use the related icons.
// Keep default order = render order for buttons

export default {

  Home: 'Home',
  CRS: 'CRS',
  DocumentLibrary: 'DocumentLibrary',
  Training: 'Training',
  ServiceRequests: 'ServiceRequests',
  SOCSCMS: 'SOCSCMS',
  PRT: 'PRT',
  SMART: 'SMART',
  CSRS: 'CSRS',
  Protocols: 'Protocols',
  GrantCapture: 'GrantCapture',
  Results: 'Results',
  Development: 'Development',
  Initiation: 'Initiation',
  InProgress: 'InProgress',
  CloseOut: 'CloseOut',
  SARF: 'SARF'

}
